class Header
{
	mobileMenuButton: any;
	navbar: any;
	navTextLinks: NodeListOf<Element>;
	subMenus: NodeListOf<Element>;
	backLinks: NodeListOf<Element>;
	subMenusChildren: NodeListOf<Element>;


	constructor(el: Element)
	{
		this.publishHeaderHeight(el);

		this.mobileMenuButton = el.querySelector(".header__links__mobile-button");
		this.navbar = el.querySelector(".header__links__nav");
		this.navTextLinks = el.querySelectorAll(".text-link[data-sub-menu]")
		this.subMenus = el.querySelectorAll(".header-sub-menu[data-sub-menu]")
		this.backLinks = el.querySelectorAll("[data-back]");
		this.subMenusChildren = el.querySelectorAll(".header-sub-menu__links__children");


		if (this.mobileMenuButton && this.navbar)
		{
			this.mobileMenuButton.addEventListener("click", () =>
			{
				this.navbar?.classList.toggle("open");


				let menuButtonIcon = this.mobileMenuButton.querySelector(".bx");
				let menuButtonSpan = this.mobileMenuButton.querySelector("span");

				if (menuButtonIcon && menuButtonSpan)
				{
					if (this.navbar?.classList.contains("open"))
					{
						menuButtonIcon.classList.remove("bx-menu");
						menuButtonIcon.classList.add("bx-x");

						menuButtonSpan.innerText = "Close";

						this.mobileMenuButton.ariaExpanded = "true";
					}
					else
					{
						menuButtonIcon.classList.add("bx-menu");
						menuButtonIcon.classList.remove("bx-x");

						menuButtonSpan.innerText = "Menu";

						this.mobileMenuButton.ariaExpanded = "false";
					}
				}


			});
		}

		if (this.navTextLinks && this.subMenus)
		{
			this.navTextLinks.forEach(link =>
			{
				link.addEventListener("click", (e) =>
				{
					this.menuToggle(link);
				});

				link.addEventListener("keydown", (e) =>
				{
					if ((e as KeyboardEvent).key === "Enter" || ((e as KeyboardEvent).key === "ArrowDown" && link.ariaExpanded) == "false")
					{
						this.menuToggle(link);
					}
					else if (((e as KeyboardEvent).key === "ArrowDown" && link.ariaExpanded) == "true")
					{
						(link as any).parentElement.querySelector(".header-sub-menu__links__parent-link").focus()
					}
					else if (((e as KeyboardEvent).key === "ArrowUp" && link.ariaExpanded) == "true")
					{
						this.menuToggle(link);
					}
				});
			});
		}

		if (this.backLinks)
		{
			this.backLinks.forEach(link =>
			{
				link.addEventListener("click", (e) =>
				{
					this.subMenus.forEach(subMenu =>
					{
						subMenu.classList.remove("open");
						let subMenuId = subMenu.getAttribute("data-sub-menu");
						var parentLink = document.querySelector(`.text-link[data-sub-menu="${subMenuId}"]`);

						if (parentLink)
						{
							parentLink.ariaExpanded = "false";
						}
					});
				});
			});
		}

		if (this.subMenusChildren)
		{
			this.subMenusChildren.forEach(childMenu =>
			{
				childMenu.querySelectorAll(".text-link").forEach(link =>
				{
					link.addEventListener("keydown", (e) =>
					{
						if ((e as KeyboardEvent).key === "ArrowDown")
						{
							(link as any).nextElementSibling?.focus();
						}
						else if ((e as KeyboardEvent).key === "ArrowUp")
						{
							(link as any).previousElementSibling?.focus();
						}
					});
				});

				childMenu.querySelector(".text-link")?.addEventListener("keydown", (e) =>
				{
					if ((e as KeyboardEvent).key === "ArrowUp")
					{
						(childMenu.closest("li")?.querySelector(".header-sub-menu__links__parent-link") as any).focus();
					}
				});
			});
		}


		if (this.subMenus)
		{
			this.subMenus.forEach(subMenu =>
			{
				subMenu.querySelector(".header-sub-menu__links__parent-link")?.addEventListener("keydown", (e) =>
				{
					if ((e as KeyboardEvent).key === "ArrowUp")
					{
						(subMenu.closest("li")?.querySelector(".text-link") as any).focus();
					}
					else if ((e as KeyboardEvent).key === "ArrowDown")
					{
						(subMenu.closest("li")?.querySelector(".header-sub-menu__links__children .text-link") as any).focus();
					}
				});
			});
		}
	}

	publishHeaderHeight(el: Element)
	{
		let setHeight = () =>
		{
			(el as HTMLElement).style.setProperty("--header-height", `${(el as HTMLElement).offsetHeight}px`);
		};

		setHeight();

		if (typeof ResizeObserver !== "undefined")
		{
			new ResizeObserver(setHeight).observe(el);
		}
		else
		{
			window.addEventListener("resize", setHeight);
		}
	}

	menuToggle(link: Element)
	{
		let subMenuId = link.getAttribute("data-sub-menu");
		if (subMenuId)
		{
			this.subMenus.forEach(subMenu =>
			{
				if (subMenu.getAttribute("data-sub-menu") === subMenuId)
				{
					subMenu.classList.toggle("open");

					this.navTextLinks.forEach(navTextLinksItems =>
					{
						if (navTextLinksItems !== link)
						{
							navTextLinksItems.ariaExpanded = "false";
						}
					});

					link.ariaExpanded = subMenu.classList.contains("open") ? "true" : "false";
				}
				else
				{
					subMenu.classList.remove("open");
				}
			});
		}
	}
}


document.querySelectorAll(".header").forEach(el =>
{
	new Header(el);
});